import style from "../../../assets/global-style";
import styled, { keyframes } from "styled-components";
import disc from "./disc.png";
import needle from "./needle.png";

const rotate = keyframes`
    0%{
        transform: rotate(0)
    }
    100%{
        transform: rotate(360deg)
    }
`;
export const NormalPlayerContainer = styled.div`
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background: ${style["background-color"]};
  .background {
    position: absolute;
    left: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: -1;
    opacity: 0.6;
    filter: blur(20px);
    &.layer {
      background: ${style["font-color-desc"]};
      opacity: 0.3;
      filter: none;
    }
  }

  &.normal-enter,
  &.normal-exit-done {
    .top {
      transform: translate3d(0, -100px, 0);
    }
    ,
    .bottom {
      transform: translate3d(0, 100px, 0);
    }
  }
  &.normal-enter-active,
  &.normal-exit-active {
    .top,
    .bottom {
      transform: translate3d(0, 0, 0);
      transition: all 0.4s cubic-bezier(0.86, 0.18, 0.82, 1.32);
    }
    opacity: 1;
    transition: all 0.4s;
  }
  &.normal-exit-active {
    opacity: 0;
  }
  &.normal-enter,
  &.normal-exit-done {
    .top {
      transform: translate3d(0, -100px, 0);
    }
    .bottom {
      transform: translate3d(0, 100px, 0);
    }
  }
  &.normal-enter-active,
  &.normal-exit-active {
    .top,
    .bottom {
      transform: translate3d(0, 0, 0);
      transition: all 0.4s cubic-bezier(0.86, 0.18, 0.82, 1.32);
    }
    opacity: 1;
    transition: all 0.4s;
  }
  &.normal-exit-active {
    opacity: 0;
  }
`;
export const Top = styled.div`
  position: relative;
  margin-bottom: 25px;
  border-bottom: 1px solid ${style["border-color-v2"]};
  width: 100%;
  height: 8%;
  .back {
    position: absolute;
    top: 0;
    left: 6px;
    z-index: 50;
    font-size: 24px;
    color: ${style["font-color-desc"]};
    font-weight: bold;
    transform: rotate(90deg);
  }
  .title {
    width: 70%;
    margin: 0 auto;
    line-height: 40px;
    text-align: center;
    font-size: ${style["font-size-l"]};
    color: ${style["font-color-desc"]};
    // ${style.noWrap()};
  }
  .subtitle {
    line-height: 20px;
    text-align: center;
    font-size: ${style["font-size-m"]};
    color: ${style["font-color-desc-v2"]};
    // ${style.noWrap()};
  }
`;
export const Middle = styled.div`
  position: fixed;
  width: 100%;
  top: 8%;
  bottom: 170px;
  white-space: nowrap;
  font-size: 0;
  overflow: hidden;
`;
export const CDWrapper = styled.div`
  width: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  display: flex;
  justify-content: center;
  box-sizing: border-box;
  .needle {
    position: absolute;
    top: -6vw;
    left: 48vw;
    width: 24vw;
    height: 36vw;
    z-index: 100;
    background-image: url(${needle});
    ${style.bigFull()};
    transform-origin: 4.5vw 4.5vw;
    transition: all 0.3s;
    tranform: rotate(0);
    &.pause {
      transform: rotate(-45deg);
    }
  }
  .cd {
    position: absolute;
    top: 16%;
    height: 70vw;
    width: 70%;
    border-radius: 50%;
    background-image: url(${disc});
    border: 4px solid ${style["border-color-v2"]};
    border-radius: 50%;
    ${style.bigFull()};
    .image {
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      margin: auto;
      position: absolute;
      width: 68%;
      height: 68%;
      border-radius: 50%;
      animation: ${rotate} 20s linear infinite;
    }

    .pause {
      animation-play-state: paused;
    }
  }
`;

export const Bottom = styled.div`
  position: absolute;
  bottom: 50px;
  width: 100%;
`;
export const ProgressWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 80%;
  margin: 0px auto;
  padding: 10px 0;
  .time {
    line-height: 30px;
    width: 30px;
    flex: 0 0 30px;
    color: ${style["font-color-desc"]};
    font-size: ${style["font-size-s"]};
    &.time-l {
      text-align: left;
    }
    &.time-r {
      text-align: right;
    }
  }
  .progress-bar-wrapper {
    flex: 1;
  }
`;
export const Operators = styled.div`
  display: flex;
  align-items: center;
  .icon {
    flex: 1;
    font-weight: 300;
    color: ${style["font-color-desc"]};
    &.disable {
      color: ${style["theme-color-shadow"]};
    }
    i {
      font-size: 30px;
    }
  }
  .i-left {
    text-align: right;
  }
  .i-center {
    padding: 0 20px;
    text-align: center;
    i {
      font-size: 40px;
    }
  }
  .i-right {
    text-align: left;
  }
`;
export const LyricContainer = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
`;
export const LyricWrapper = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  box-sizing: border-box;
  text-align: center;
  p{
    color: rgba(255, 255, 255, 0.5);
    &.pure {
      position: relative;
      top: 60vh;
    }
  }
 
`;
export const List = styled.div`
  width: 70%;
  margin: auto;  
  display: flex;
  align-items: center;
  // justify-content: space-around;
  >span:first-of-type {
    // display: block;
    flex: 2 3 auto;
    padding: 5px 0;
    color: ${style["font-color-desc-v2"]};
    font-size: ${style["font-size-m"]};
    // vertical-align: middle;
  }
`
export const ListItem = styled.span`
  flex: 1 1 auto;
  border-radius: 10px;
  padding: 5px 10px;
  display: block;
  color: ${style["font-color-desc-v2"]};
  &.selected {
    color: ${style["theme-color"]};
    border: 1px solid;
    opacity: 0.8;
  }
`